import { z } from "zod";

import { phoneValueSchema } from "../../ManageStudent/validation/phoneFieldSchema";

export const agentPhoneSearchSchema = z.object({
  phone: z.preprocess(
    (val) => (val === undefined ? "" : val),
    phoneValueSchema.min(1, "Phone number is required"),
  ),
});
